module.exports = __webpack_public_path__ + "img/ico_biaoqianjianzaoyanfa.a84abbe8.png";